__turbopack_context__.v({
  "answer": "faqItem-module-scss-module__QM3Ieq__answer",
  "chevron": "faqItem-module-scss-module__QM3Ieq__chevron",
  "faqItem": "faqItem-module-scss-module__QM3Ieq__faqItem",
  "opened": "faqItem-module-scss-module__QM3Ieq__opened",
  "question": "faqItem-module-scss-module__QM3Ieq__question",
});
